import { styled } from "@mui/material/styles";
import { Icons as GridIcons } from "Components/AppGrid/shipeezi-new-grid";
import { HiOutlineCurrencyDollar } from "react-icons/hi";

export const StorageAccountsGrid = styled("div")(() => ({
  padding: "24px 32px",
  display: "flex",
  flexDirection: "row",
  "& > div": {
    width: "100%",
  },
}));

export const StorageAccountPrice = styled("div")(() => ({
  color: "#0055A4",
  textAlign: "right",
  fontSize: "12px",
  fontFamily: "Manrope",
  fontWeight: 600,
}));

export const ChangeStatusIcon = styled(GridIcons.status)(() => ({
  cursor: "pointer",
}));

export const DeleteIcon = styled(GridIcons.delete)(() => ({
  cursor: "pointer",
}));

export const ViewIcon = styled(GridIcons.view)(() => ({
  cursor: "pointer",
}));

export const SendEMailIcon = styled(GridIcons.email)(() => ({
  cursor: "pointer",
}));

export const SettlementIcon = styled(HiOutlineCurrencyDollar)(() => ({
  cursor: "pointer",
}));
